// extracted by mini-css-extract-plugin
export default {"text":"Service_text__tU8Pi"};